// extracted by mini-css-extract-plugin
module.exports = {"scroll-black":"Content_scroll-black__ijWN_","content":"Content_content__XRTef"};